module.exports = __webpack_public_path__ + "static/media/user.5bef5853.svg";